import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { ArrowUp, ArrowDown } from "lucide-react";
import { MeetingNotes } from "../../types/meetings";
import { formatDate } from "../../lib/utils";

interface ActionItemContextProps {
  actionItem: any;
  showContext: boolean;
  setShowContext: (show: boolean) => void;
  meetingNotes: MeetingNotes | null;
}

export function ActionItemContext({ actionItem, showContext, setShowContext, meetingNotes }: ActionItemContextProps) {
  return (
    <Card className="bg-background">
      <CardHeader>
        <CardTitle className="text-foreground">Meeting Context</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <Badge variant="outline">{actionItem.status}</Badge>
            <span className="text-sm text-muted-foreground">
              {actionItem.created_at ? formatDate(actionItem.created_at) : 'No date'}
            </span>
          </div>

          {actionItem.context && (
            <div className="space-y-2">
              <h4 className="text-sm font-medium text-foreground">Context:</h4>
              <blockquote className="border-l-4 border-muted pl-4 italic text-muted-foreground">
                {actionItem.context}
              </blockquote>
            </div>
          )}

          <Button
            variant="outline"
            onClick={() => setShowContext(!showContext)}
            className="w-full"
          >
            {showContext ? (
              <>
                <ArrowUp className="h-4 w-4 mr-2" />
                Hide Context
              </>
            ) : (
              <>
                <ArrowDown className="h-4 w-4 mr-2" />
                Show More Context
              </>
            )}
          </Button>

          {showContext && meetingNotes?.notes && (
            <div className="p-4 bg-muted rounded-lg">
              <h4 className="font-medium mb-2 text-foreground">Related Meeting Notes</h4>
              <p className="text-sm text-muted-foreground">
                {meetingNotes.notes}
              </p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}